import createUserSessionsApi from "./userSessions";
import createPaypalApi from "./paypal";

export default (options) => ({
    userSessions: createUserSessionsApi(options),
    paypal: createPaypalApi(options)
})
